import {
  Box,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Passagem as IPassagem } from "../../utils/interfaces";
import { IoTicketOutline } from "react-icons/io5";
import Swal from "sweetalert2";
import { isRs } from "../../utils/currency";

export function Selecionada() {
  const [passagens, setPassagens] = useState<IPassagem[]>([]);

  const { watch } = useFormContext();

  const selecionada: IPassagem = watch("selecionada");

  useEffect(() => {
    if (selecionada) {
      setPassagens((state) => {
        if (
          state.find(
            (item: IPassagem) => item.contexto === selecionada.contexto
          )
        ) {
          return [selecionada];
        } else {
          return [...state, selecionada];
        }
      });

      if (selecionada.viacao.alerta) {
        const alerta = selecionada.viacao.alerta;
        Swal.fire({
          icon: alerta.icon,
          title: alerta.title,
          text: alerta.mensagem,
          confirmButtonText: alerta.confirmButtonText,
          allowEscapeKey: false,
          allowOutsideClick: false,
          position: "center",
          toast: false,
        });
      }

      if(isRs(selecionada.origemLabel, selecionada.destinoLabel)){
        Swal.fire({
          title: 'Atenção!',
          icon: 'warning',
          text: 'Devido a essa viagem ser uma viagem intermunicipal dentro do estado do Rio Grande do Sul, é obrigatório a impressão do BPE, bilhete de passagem eletrônico',
          confirmButtonText: 'Ciente',
          position: 'center',
          toast: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
        })
      }
    }
  }, [selecionada]);

  return (
    <Box>
      <Text fontWeight={"bold"} mt={2}>
        Viagem Selecionada
      </Text>
      {passagens.length > 0 && (
        <Box
          mt={2}
          mb={2}
          px={3}
          py={2}
          borderRadius={"md"}
          border={"1px solid #f6ad55"}
          bg={"#fffaf0"}
        >
          <Text fontSize={"sm"} color={"#7b341e"} fontWeight={"bold"}>
            Limite de bilhetes por pedido
          </Text>
          <Text fontSize={"sm"} color={"#7b341e"}>
            Máximo de 5 bilhetes de ida + 5 de volta (total de 10).
          </Text>
        </Box>
      )}

      <TableContainer maxHeight={"40vh"} overflowY={"auto"}>
        <Table
          fontSize={"sm"}
          colorScheme="gray"
          variant={passagens.length > 0 ? "striped" : "simple"}
        >
          <Thead bg={"#333333"} position={"sticky"} width={"100%"}>
            <Tr width={"100%"}>
              <Th
                color={"white"}
                fontSize={"small"}
                fontWeight={"normal"}
                py={1}
                px={1}
                textAlign={"center"}
                textTransform={"capitalize"}
              ></Th>
              <Th
                color={"white"}
                fontSize={"small"}
                fontWeight={"normal"}
                py={1}
                px={1}
                textAlign={"center"}
                textTransform={"capitalize"}
              >
                Data
              </Th>
              <Th
                color={"white"}
                fontSize={"small"}
                fontWeight={"normal"}
                py={1}
                px={1}
                textAlign={"center"}
                textTransform={"capitalize"}
              >
                Classe
              </Th>
              <Th
                color={"white"}
                fontSize={"small"}
                fontWeight={"normal"}
                py={1}
                px={1}
                textAlign={"center"}
                textTransform={"capitalize"}
              >
                Valor
              </Th>
              <Th
                color={"white"}
                fontSize={"small"}
                fontWeight={"normal"}
                py={1}
                px={1}
                textAlign={"center"}
                textTransform={"capitalize"}
              >
                Origem
              </Th>
              <Th
                color={"white"}
                fontSize={"small"}
                fontWeight={"normal"}
                py={1}
                px={1}
                textAlign={"center"}
                textTransform={"capitalize"}
              >
                Destino
              </Th>
              <Th
                color={"white"}
                fontSize={"small"}
                fontWeight={"normal"}
                py={1}
                px={1}
                textAlign={"center"}
                textTransform={"capitalize"}
              >
                Empresa
              </Th>
            </Tr>
          </Thead>
          <Tbody height={"100%"}>
            {passagens.length > 0 ? (
              passagens.map((item) => (
                <Tr
                  key={`${item.servico}`}
                  _hover={{ backgroundColor: "orange", color: "white" }}
                  className="group"
                >
                  <Td px={0} py={1} textAlign={"center"}>
                    {item.contexto}
                  </Td>
                  <Td
                    px={0}
                    py={1}
                    textAlign={"center"}
                    _groupHover={{ backgroundColor: "orange", color: "white" }}
                  >
                    {item.saidaDia} {item.saidaHora}
                  </Td>

                  <Td
                    px={0}
                    py={1}
                    textAlign={"center"}
                    _groupHover={{ backgroundColor: "orange", color: "white" }}
                  >
                    {item.classe}
                  </Td>
                  <Td
                    px={0}
                    py={1}
                    textAlign={"center"}
                    _groupHover={{ backgroundColor: "orange", color: "white" }}
                  >
                    {item.preco}
                  </Td>
                  <Td
                    px={0}
                    py={1}
                    textAlign={"center"}
                    _groupHover={{ backgroundColor: "orange", color: "white" }}
                  >
                    {item.origemLabel}
                  </Td>
                  <Td
                    px={0}
                    py={1}
                    textAlign={"center"}
                    _groupHover={{ backgroundColor: "orange", color: "white" }}
                  >
                    {item.destinoLabel}
                  </Td>
                  <Td
                    px={0}
                    py={1}
                    textAlign={"center"}
                    _groupHover={{ backgroundColor: "orange", color: "white" }}
                  >
                    {item.empresa}
                  </Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan={7}>
                  <Box
                    flexDir={"column"}
                    display={"flex"}
                    width={"100%"}
                    height={"20px"}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <IoTicketOutline size={"48px"} color="'gray.500" />
                    <Text color={"gray.500"}>
                      Selecione uma viagem na lista
                    </Text>
                  </Box>
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
}
